/**
 * Folder name rules, mirrored from MediaLibraryService.UNSAFE_NAME_CHARS on the backend so the
 * user gets immediate feedback instead of a round-trip 400. The backend remains the authority.
 *
 * Deliberately a deny-list: an allow-list here kept rejecting ordinary names nobody had thought
 * of. Only the separators and the three characters that would break the asset's CloudFront URL
 * are refused.
 */
const UNSAFE_NAME_CHARS = /[/\\#?%\u0000-\u001F\u007F-\u009F]/;

export const MAX_FOLDER_NAME_LENGTH = 255;

/**
 * @returns an error message, or null when the name is valid
 */
export const validateFolderName = (name: string): string | null => {
  const trimmed = name.trim();

  if (!trimmed) {
    return 'Folder name is required';
  }
  if (trimmed.length > MAX_FOLDER_NAME_LENGTH) {
    return `Folder name cannot exceed ${MAX_FOLDER_NAME_LENGTH} characters`;
  }
  if (trimmed.includes('/') || trimmed.includes('\\')) {
    return 'Folder name cannot contain slashes';
  }
  if (trimmed.includes('..') || trimmed.includes('~')) {
    return "Folder name cannot contain '..' or '~'";
  }
  if (UNSAFE_NAME_CHARS.test(trimmed)) {
    return 'Folder name cannot contain # ? or %';
  }

  return null;
};

/**
 * Pull the backend's message off an axios error, falling back to a caller-supplied default.
 */
export const getApiErrorMessage = (error: unknown, fallback: string): string => {
  const message = (error as { response?: { data?: { message?: string } } })?.response?.data?.message;
  return message || fallback;
};
